import React, { useEffect, useState } from 'react';
import { Users, ExternalLink, Instagram, Loader2 } from 'lucide-react';
import { apiBaseURL } from '../config/env';

interface SocialSettings {
    networking_group_url: string;
    instagram_url: string;
}

export const Networking: React.FC = () => {
    const [settings, setSettings] = useState<SocialSettings | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${apiBaseURL}/public/social-settings`)
            .then(r => r.json())
            .then(d => setSettings(d))
            .catch(() => setSettings({ networking_group_url: '', instagram_url: '' }))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <Loader2 size={24} className="animate-spin text-orange-500" />
            </div>
        );
    }

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <div className="mb-8">
                <h1 className="text-2xl font-bold text-white flex items-center gap-2">
                    <Users className="text-orange-500" size={24} /> Grupo de Networking
                </h1>
                <p className="text-gray-500 text-sm mt-1">
                    Conecte-se com outros usuários da plataforma e cresça junto com a comunidade.
                </p>
            </div>

            {/* Card Grupo */}
            <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-8 mb-6 text-center">
                <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5"
                    style={{ background: 'linear-gradient(135deg, #ff6a00, #ee0979)' }}
                >
                    <Users size={28} className="text-white" />
                </div>

                <h2 className="text-white font-bold text-xl mb-2">Comunidade Hotlize</h2>
                <p className="text-gray-400 text-sm mb-6 max-w-sm mx-auto">
                    Faça parte do nosso grupo exclusivo. Troque experiências, tire dúvidas e fique por dentro das novidades em primeira mão.
                </p>

                {settings?.networking_group_url ? (
                    <a
                        href={settings.networking_group_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-8 py-3 rounded-xl bg-orange-600 hover:bg-orange-500 text-white font-bold text-sm transition-all hover:scale-105"
                    >
                        <ExternalLink size={16} />
                        Entrar no Grupo
                    </a>
                ) : (
                    <span className="text-gray-600 text-sm italic">Link do grupo ainda não configurado.</span>
                )}
            </div>

            {/* Card Instagram */}
            <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-8 text-center">
                <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5"
                    style={{ background: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)' }}
                >
                    <Instagram size={28} className="text-white" />
                </div>

                <h2 className="text-white font-bold text-xl mb-2">Siga-nos no Instagram</h2>
                <p className="text-gray-400 text-sm mb-6 max-w-sm mx-auto">
                    Conteúdo exclusivo, dicas de automação e bastidores da plataforma. Não perca nenhuma atualização.
                </p>

                {settings?.instagram_url ? (
                    <a
                        href={settings.instagram_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-8 py-3 rounded-xl text-white font-bold text-sm transition-all hover:scale-105"
                        style={{ background: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)' }}
                    >
                        <Instagram size={16} />
                        Seguir no Instagram
                    </a>
                ) : (
                    <span className="text-gray-600 text-sm italic">Instagram ainda não configurado.</span>
                )}
            </div>
        </div>
    );
};
